module.exports = __webpack_public_path__ + "static/media/vg.18147523.svg";